module.exports = __webpack_public_path__ + "static/media/87.fb60f56a.jpg";